/** One immutable UTC day. The demo has no connection to the live D1 database. */
export const DEMO_DATE = "2026-08-15";
export const DEMO_SINCE = `${DEMO_DATE}T00:00:00.000Z`;
export const DEMO_UNTIL = `${DEMO_DATE}T23:59:59.999Z`;
export const DEMO_NOW = Date.parse(DEMO_UNTIL);
export const DEMO_LABEL = "15 August 2026";
export const DEMO_DATA_PATH = "/demo-data/2026-08-15";

export function isDemoPath(path: string): boolean {
  return /^\/demo(?:\/|[?#]|$)/.test(path);
}

export function demoAppPath(path: string): string {
  return isDemoPath(path) ? path : `/demo${path === "/" ? "" : path}`;
}

export type DemoSource = {
  source: string;
  status: "complete" | "partial" | "unavailable";
  count: number;
  retrieved_at: string;
  note?: string;
};

export type DemoManifest = {
  date: string;
  since: string;
  until: string;
  built_at: string;
  detections: number;
  incidents: number;
  sources: DemoSource[];
};
